import React, { Component } from 'react';
import { isMobile } from '../../utils/deviceInfo';
import ww from '../../assets/onboarding/ww.png';
import { Link } from 'react-router-dom';
import welcome from '../../assets/onboarding/welcome.png';
import analytics from '../../assets/onboarding/analytics.png';
import { Modal, ModalBody } from 'reactstrap';
import officeCreatedIcon from '../../assets/office_created_icon.svg';
import 'rc-checkbox/assets/index.css';
import drillDownClose from '../../assets/drilldown_close.svg';
import stories from '../../assets/onboarding/Stories.png';
import welcomeStory from '../../assets/onboarding/wStory.svg';
import {storyTemplates, staticTitles} from '../../utils/constants'
import axios from '../../axios';
import * as url from '../../utils/url';
import { connect } from 'react-redux';
import wtEngageImg from '../../assets/onboarding/wtEngageImg.png';
import wtAnalyticsImg from '../../assets/onboarding/wtAnalyticsImg.png';
import wtActionImg from '../../assets/onboarding/wtActionImg.png';
import wtResourceImg from '../../assets/onboarding/wtResourceImg.png';
import { withRouter } from 'react-router-dom';
import * as actionCreators from '../../modules/actions/index';




class IntroModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      removedIntro: "Don't show this again",
      showIntro:this.props.showIntro,
      isRemoved:this.props.isRemoved
    }
  }


  closeIntroModal=()=>{
    this.setState({showIntro:  false})
    this.props.closeIntroModal()
  }


  neverShowIntro=()=>{
    let that=this
    axios.post(url.removeIntro).then(({data}) => {
      that.setState({
        removedIntro:"This message will no longer be shown.",
        isRemoved:true
      })
      that.props.onProfileUpdate({hideIntro:true});
    });
  }
      

  navigateToPage =(module)=>{
    let{pathname}=this.props.history.location
    if(module=='A'){
      if(pathname.indexOf('/home/analytics/all')==-1) return this.props.history.push(`/home/analytics/all`)
      this.closeIntroModal()
    }else if(module=='T'){
      if(pathname.indexOf('/home/toolkit/all')==-1) return this.props.history.push(`/home/toolkit/all`)
      this.closeIntroModal()
    }else if(module=='C'){
      if(pathname.indexOf('/home/stories')==-1) return this.props.history.push(`/home/stories`)
      this.closeIntroModal()
    }else if(module=='P'){
      if(pathname.indexOf('/home/my-activity')==-1) return this.props.history.push(`/home/my-activity`)
      this.closeIntroModal()
    }
  }


  render() {
    let{profile}=this.props.user 
    let org = profile.organizationId
    return (
      <Modal className="welcomemodalparent"
      isOpen={false} style={{ marginTop: (isMobile ? "15vh" : "16vh") }}>
      <ModalBody className="storyModalBody">
        <button className="onBoarding-modal-close" onClick={()=>this.closeIntroModal()}>
          <img src={drillDownClose} height="35px" width="35px" />
        </button>
      
      <div className="col-sm-12 col-md-12 displayFlex">
      
      { (org.selectModule && org.isPlanning && org.isPlanning.status) || (!org.selectModule||org.selectModule==undefined||org.selectModule==null)?
      <div className="onBoarding container">
        <span onClick={()=>this.navigateToPage('P')} ><img className="onBoarding" src={wtActionImg} style={{ margin: '0px 5px 20px' }} /></span>
      </div>
      :null}
      
      { (org.selectModule && org.isAnalytics && org.isAnalytics.status) || (!org.selectModule||org.selectModule==undefined||org.selectModule==null)?
      <div className="onBoarding container">
                <span onClick={()=>this.navigateToPage('A')} 
                
                >
                  <img className="onBoarding" src={wtAnalyticsImg} style={{ margin: '0px 5px 2px' }} />
                </span>
      </div>:null}
      
      
      { (org.selectModule && org.isCultureApp && org.isCultureApp.status) || (!org.selectModule||org.selectModule==undefined||org.selectModule==null)?
      <div onClick={()=>this.navigateToPage('C')}
      className="onBoarding container">
                    <img className="onBoarding" src={wtEngageImg} style={{ margin: '0px 5px 2px' }} onClick={()=>this.closeIntroModal()} />
      </div>:null}
      
      { (org.selectModule && org.isToolkit && org.isToolkit.status) || (!org.selectModule||org.selectModule==undefined||org.selectModule==null)?
          <div className="onBoarding container">
            <span onClick={()=>this.navigateToPage('T')}
      >
              <img className="onBoarding" src={wtResourceImg} style={{ margin: '0px 5px 2px' }} />
            </span>
          </div>
      :null}
      
      </div>
      
      
      <div className="col-sm-12 col-md-12 displayFlex">
      
      
      { (org.selectModule && org.isPlanning && org.isPlanning.status) || (!org.selectModule||org.selectModule==undefined||org.selectModule==null)?                              
      <div className="onBoarding container">
        <div>Take Action</div>
                {/* <ul>
                  <li>Share key objectives</li>
                  <li> Assign & take Action</li>
                  <li> Track progress</li>
                </ul> */}
                <div className="introModalCatTxt"> 
                  Share key objectives, Assign & take action, <br/>See progress
                </div>
              <span onClick={()=>this.navigateToPage('P')}
               className="removeOnboarding"> Go to Planning →</span>
      </div>:null}
      
      
      { (org.selectModule && org.isAnalytics && org.isAnalytics.status) || (!org.selectModule||org.selectModule==undefined||org.selectModule==null)?
      <div className="onBoarding container">
          <div>Measure</div>
                {/* <ul>
                  <li>See big picture trends</li>
                  <li>Drill into the details</li>
                  <li>Set goals, track progress</li>
                </ul> */}
                <div className="introModalCatTxt"> 
                  See big picture trends, Drill into the details, Set goals & track KPIs
                </div>
                <span onClick={()=>this.navigateToPage('A')}
                  className="removeOnboarding"> Go to Analytics →</span>
      </div>:null}
      
      
      { (org.selectModule && org.isCultureApp && org.isCultureApp.status) || (!org.selectModule||org.selectModule==undefined||org.selectModule==null)?
      <div className="onBoarding container">
              <div>Engage</div>
                        {/* <ul>
                          <li>Share in a safe space</li>
                          <li>Connect & listen </li>
                          <li>See what’s trending</li>
                        </ul> */}
                      <div className="introModalCatTxt"> 
                        Share in a safe space, Connect & listen, <br/>See what’s trending
                      </div>
                      <span onClick={()=>this.navigateToPage('C')}
                      to={'/home/stories'} className="removeOnboarding"> Go to Culture App →</span>
        </div>:null}
      
      
      
      { (org.selectModule && org.isToolkit && org.isToolkit.status) || (!org.selectModule||org.selectModule==undefined||org.selectModule==null)?
        <div className="onBoarding container">
              <div>Resources</div>
                        {/* <ul>
                          <li>Share in a safe space</li>
                          <li>Connect & listen </li>
                          <li>See what’s trending</li>
                        </ul> */}
                      <div className="introModalCatTxt"> 
                        Crowdsourced, rated content & expert recommendations
                      </div>
                      <span onClick={()=>this.navigateToPage('T')}
                       className="removeOnboarding"> See Resources →</span>
        </div>:null}
      </div>
      
      <div className={`mt40`}>
                      {this.state.isRemoved ?
                        <div className="onBoardingButtons dontShowMsg">
                          <img src={officeCreatedIcon} style={{ paddingRight: "5px" }} />
                          <span className="">
                    {this.state.removedIntro}
                    </span>
                        </div>
                        :
                        <div className="onBoardingButtons" style={{ cursor: "pointer" }} onClick={()=>this.neverShowIntro()}>
                          <span className="neverShowOnboardingModal">{this.state.removedIntro}</span>
                        </div>
                      }
        </div>
                 
      
      
      </ModalBody>
      </Modal>
    );
  }
}

// export default IntroModal;

// export default connect(null, null)(IntroModal);

const mapStateToProps = state => {
  return {
    user: state.user,
    kpiMaster: state.kpiMaster,
    mappingMaster: state.mappingMaster,
    reports:state.reports
  }
}

const mapDispatchToProps = dispatch => {
  return {
    onKpiMasterListFetched: (data) => dispatch(actionCreators.storeKpiMaster(data)),
    onMappingMasterListFetched: (data) => dispatch(actionCreators.storeMappingMaster(data)),
    onProfileUpdate: (data) => dispatch(actionCreators.updateProfileInfoSuccess(data)),
    updateNavBar: (header) => dispatch(actionCreators.navBarUpdate(header)),
    updateReport: (dashboard) => dispatch(actionCreators.updateReport(dashboard))

  }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(IntroModal));


